export const PROVIDER_NAME_SEARCH_ID = 'provider-name-search'
